// routes
import { PATH_CONTACT_CENTER, PATH_ONLINE } from './routes/paths';
// import { PATH_ONLINE_V2, PATH_CONTACT_CENTER_V2 } from './routes/paths-v2';

//** V1 */
// export const PATH_AFTER_LOGIN = PATH_ONLINE.accept;
// export const PATH_AFTER_LOGIN_CC = PATH_CONTACT_CENTER.openingScript;

//** V2 */
export const PATH_AFTER_LOGIN = PATH_ONLINE.gettingStarted;
export const PATH_AFTER_LOGIN_CC = PATH_CONTACT_CENTER.gettingStarted;
